import {
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFieldComponent } from '../../models/dynamic-field-component';
import { DynamicFormEntry } from '../../models/dynamic-form-entry';
import { FormInputComponent } from '../form-input/form-input.component';
import { HeaderLabelComponent } from '../header-label/header-label.component';
import { LabelComponent } from '../label/label.component';

@Directive({
  selector: '[bomDynamicField]',
})
export class DynamicFieldDirective implements OnInit {
  @Input()
  config: DynamicFormEntry;

  @Input()
  group: FormGroup;

  @Input()
  showHentFraMinProfilButton: boolean;

  @Input()
  hentFraMinProfilButton: TemplateRef<any>;

  component: ComponentRef<any>;

  constructor(private resolver: ComponentFactoryResolver, private container: ViewContainerRef) {}

  ngOnInit() {
    const factory = this.resolveComponentFactory(this.config);
    this.component = this.container.createComponent(factory);
    this.component.instance.config = this.config;
    this.component.instance.group = this.group;
    this.component.instance.showHentFraMinProfilButton = this.showHentFraMinProfilButton;
    this.component.instance.hentFraMinProfilButton = this.hentFraMinProfilButton;
  }

  private resolveComponentFactory(config: DynamicFormEntry): any {
    switch (config.type) {
      case 'headerlabel':
        return this.resolver.resolveComponentFactory<DynamicFieldComponent>(HeaderLabelComponent);
      case 'label':
        return this.resolver.resolveComponentFactory<DynamicFieldComponent>(LabelComponent);
      default:
        return this.resolver.resolveComponentFactory<DynamicFieldComponent>(FormInputComponent);
    }
  }
}
